<template>
  <div class="withdrawscore">
    <div class="top_">
      <p class="item_1">
        <span class="symbol_">¥</span>
        <span class="score_">{{scoreData.actualWithdrawalAmount}}</span>
        <span class="unit_">元</span>
      </p>
      <p class="item_2">
        实际提取金额
      </p>
    </div>
    <!-- 账号为开票时，提现页面显示提现金额明细 -->
    <div v-if="invoiceType == 'Y'" class="bank_list score-detail">
      <div class="bank_item">
        <p class="title">实际提取金额</p>
        <p>{{scoreData.actualWithdrawalAmount}}</p>
      </div>
      <div class="bank_item">
        <p class="title">可提取积分金额</p>
        <p>{{scoreData.totalIntegral}}</p>
      </div>
      <div class="bank_item">
        <p class="title">补税金额</p>
        <p>{{scoreData.taxPaymentAmount}}</p>
      </div>
      <div class="bank_item">
        <p class="title">结算规则</p>
        <div>
          <p>实际提现金额=提现金额+税补金额</p>
          <p>提示:请提供符合要求的增值税发票:税点=6%</p>
          <p>价税合计金额=实际提现金额</p>
        </div>
      </div>
    </div>
    <div class="bank_list">
      <p class="item_3">
        您用于提现的银行卡如下
      </p>
      <div class="bank_item"
           v-for="(item,index) in scoreData.bankCardList"
           :key="index">
        <div class="left_">
          <img :src="banks[item.bankCardCodeShort]"
               alt="" />
          <div class="ltop_">
            <div style="display: flex;align-items: center;">
              <div class="num">{{index + 1}}</div>
              <div class="name_">{{item.receiverName}}</div>
            </div>
            <div class="card_">
              {{item.bankCardCode}}
            </div>
          </div>
        </div>
         <!-- 开票账号（对公）不需要展示”可用余额项“ -->
        <div class="right_" v-if="invoiceType == 'N'">
          <div class="money_">{{item.forceAmount}}</div>
          <div class="text_">可用余额</div>
        </div>
      </div>
    </div>
    <div class="tips_">
      <p class="title_">
        提现须知
      </p>
      <div class="notes_" v-if="invoiceType == 'N'">
        <p>1.每个户名单个自然月累计提现金额上限147000元。</p>
        <p>
          2.当银行卡提现金额超过单张银行卡可用金额时，将按序号顺序依次使用银行卡。
        </p>
        <p>
          3.如所有银行卡可用余额均为0时，请添加新的银行卡，或于下一个自认月提现。
        </p>
        <p>
          4.平台于每个工作周的周二统一支付前7天提现的积分，如遇节假日或其他不可抗力因素，自动顺延。
        </p>
      </div>
      <div class="notes_" v-if="invoiceType == 'Y'">
        <p>1.您的账户类型是开票结算类型，请提供科目为服务费的增值税发票。</p>
        <p>
          2.平台将于收到发票后的3个工作日内支付。
        </p>
      </div>
    </div>
    <div v-if="$route.query.isTongjieNoFirst !== 'Y'" class="bottom_ read_">
      <div style="display: flex;align-items: center;" @click="check">
        <img src="../../../assets/image/bs-2.0/unchecked.png"
             alt="" v-if="!checked">
             <img src="../../../assets/image/bs-2.0/checked.png"
             alt="" v-else>
        <span class="read_">本人已阅读并确认上述提现金额及提现须知</span>
      </div>
      <div class="withdraw_btn" @click="withdraw">提现</div>
    </div>
  </div>
</template>
<script>
import api from '@/utils/api'
const banks = {
  'bjbank.png': require('../../../assets/image/bs-2.0/bankicon/bjbank.png'),
  'bsbank.png': require('../../../assets/image/bs-2.0/bankicon/bsbank.png'),
  'chbank.png': require('../../../assets/image/bs-2.0/bankicon/chbank.png'),
  'gdbank.png': require('../../../assets/image/bs-2.0/bankicon/gdbank.png'),
  'gfbank.png': require('../../../assets/image/bs-2.0/bankicon/gfbank.png'),
  'gsbank.png': require('../../../assets/image/bs-2.0/bankicon/gsbank.png'),
  'hxbank.png': require('../../../assets/image/bs-2.0/bankicon/hxbank.png'),
  'jsbank.png': require('../../../assets/image/bs-2.0/bankicon/jsbank.png'),
  'jtbank.png': require('../../../assets/image/bs-2.0/bankicon/jtbank.png'),
  'msbank.png': require('../../../assets/image/bs-2.0/bankicon/msbank.png'),
  'nybank.png': require('../../../assets/image/bs-2.0/bankicon/nybank.png'),
  'nyfzbank.png': require('../../../assets/image/bs-2.0/bankicon/nyfzbank.png'),
  'other.png': require('../../../assets/image/bs-2.0/bankicon/other.png'),
  'pabank.png': require('../../../assets/image/bs-2.0/bankicon/pabank.png'),
  'pfbank.png': require('../../../assets/image/bs-2.0/bankicon/pfbank.png'),
  'xybank.png': require('../../../assets/image/bs-2.0/bankicon/xybank.png'),
  'yzbank.png': require('../../../assets/image/bs-2.0/bankicon/yzbank.png'),
  'zjbank.png': require('../../../assets/image/bs-2.0/bankicon/zjbank.png'),
  'zsbank.png': require('../../../assets/image/bs-2.0/bankicon/zsbank.png'),
  'zxbank.png': require('../../../assets/image/bs-2.0/bankicon/zxbank.png')

}
export default {
  data () {
    return {
      banks,
      // scoreData: {
      //   "totalIntegral": "11",
      //   "taxPaymentAmount": "222",
      //   "startDate": "",
      //   "endDate": "",
      //   "totalForceAmount": "",
      //   "actualWithdrawalAmount": "2222",
      //   "pointsAvailableForWithdrawal": "",
      //   "isTongjie": "N",
      //   "invoiceType": "",
      //   "bankCardList": [
      //     {
      //       "userId": "",
      //       "cardId": "",
      //       "idType": "",
      //       "idNumber": "",
      //       "bankBranchName": "",
      //       "bankProvince": "",
      //       "bankCity": "",
      //       "bankName": "",
      //       "bankCardCode": "",
      //       "bankCardCodeShort": "bjbank",
      //       "receiverName": "呵呵",
      //       "forceAmount": "123",
      //       "amount": "",
      //       "tax": "",
      //       "bankCardCodeStr": "",
      //     },
      //     {
      //       "userId": "",
      //       "cardId": "",
      //       "idType": "",
      //       "idNumber": "",
      //       "bankBranchName": "",
      //       "bankProvince": "",
      //       "bankCity": "",
      //       "bankName": "",
      //       "bankCardCode": "",
      //       "bankCardCodeShort": "jsbank",
      //       "receiverName": "呵呵",
      //       "forceAmount": "123",
      //       "amount": "",
      //       "tax": "",
      //       "bankCardCodeStr": "",
      //     },
      //     {
      //       "userId": "",
      //       "cardId": "",
      //       "idType": "",
      //       "idNumber": "",
      //       "bankBranchName": "",
      //       "bankProvince": "",
      //       "bankCity": "",
      //       "bankName": "",
      //       "bankCardCode": "",
      //       "bankCardCodeShort": "bsbank",
      //       "receiverName": "呵呵",
      //       "forceAmount": "123",
      //       "amount": "",
      //       "tax": "",
      //       "bankCardCodeStr": "",
      //     },
      //     {
      //       "userId": "",
      //       "cardId": "",
      //       "idType": "",
      //       "idNumber": "",
      //       "bankBranchName": "",
      //       "bankProvince": "",
      //       "bankCity": "",
      //       "bankName": "",
      //       "bankCardCode": "",
      //       "bankCardCodeShort": "xybank",
      //       "receiverName": "呵呵",
      //       "forceAmount": "123",
      //       "amount": "",
      //       "tax": "",
      //       "bankCardCodeStr": "",
      //     },
      //     {
      //       "userId": "",
      //       "cardId": "",
      //       "idType": "",
      //       "idNumber": "",
      //       "bankBranchName": "",
      //       "bankProvince": "",
      //       "bankCity": "",
      //       "bankName": "",
      //       "bankCardCode": "",
      //       "bankCardCodeShort": "jtbank",
      //       "receiverName": "呵呵",
      //       "forceAmount": "123",
      //       "amount": "",
      //       "tax": "",
      //       "bankCardCodeStr": "",
      //     }
      //   ],
      //   "userId": "",
      //   "openId": "",
      // },
      scoreData: {},
      checked: false,
      queryParams: {},
      invoiceType: ''
    }
  },
  created () {
    const { invoiceType, ...queryParams } = this.$route.query
    this.invoiceType = invoiceType
    this.queryParams = queryParams
    this.cashOut()
  },
  methods: {
    cashOut () {
      api.cashOut(this.queryParams).then(res => {
        this.scoreData = res.data.content || {}
      })
    },
    withdraw () {
      if (!this.checked) {
        this.$toast('请勾选已阅读提现须知')
        return
      }
      // 如果可提现金额小于0
      if (Number(this.scoreData.actualWithdrawalAmount) < 0) {
        this.$toast('提现金额不能小于0')
        return
      }
      let params = {
        ...this.queryParams,
        totalIntegral: this.scoreData.totalIntegral,
        taxPaymentAmount: this.scoreData.taxPaymentAmount
      }
      api.withDraw(params).then(res => {
        if (res.data.returnCode === '0000') {
          this.$router.push({
            path: '/bs/withdrawresult',
            query: {
              flag: 'success'
            }
          })
        } else {
          this.$toast(res.data.returnMsg)
        }
      })
    },
    check () {
      this.checked = !this.checked
    }
  }
}
</script>
<style lang="scss" scoped>
.withdrawscore {
  background: #fff;
  padding: 31px 20px 150px;
  .top_ {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .item_1 {
      height: 46px;
      .symbol_ {
        color: #ff7c6d;
        font-size: 16px;
        font-weight: bold;
      }
      .score_ {
        color: #ff7c6d;
        font-size: 38px;
        font-weight: bold;
        margin-left: 3px;
      }
      .unit_ {
        font-size: 12px;
        color: #666;
        margin-left: 3px;
      }
    }
    .item_2 {
      font-size: 12px;
      color: #333;
    }
  }
  .bank_list {
    margin-top: 33px;
    .item_3 {
      font-size: 12px;
      color: #999;
    }
    .bank_item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 55px;
      background: #f9f9f9;
      border-radius: 7px;
      padding: 14px 20px 17px 17px;
      margin-top: 10px;
      .left_ {
        display: flex;
        align-items: center;
        img {
          width: 24px;
          height: 24px;
        }
        .ltop_ {
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          align-items: flex-start;
          margin-left: 12px;
          .num {
            display: inline-block;
            width: 12px;
            height: 12px;
            line-height: 12px;
            background: #cecece;
            border-radius: 2px;
            font-size: 9px;
            color: #fff;
            margin-right: 6px;
          }
          .name_ {
            color: #fff;
            padding: 0 6px;
            height: 12px;
            line-height: 12px;
            background: #cecece;
            border-radius: 2px;
            font-size: 9px;
          }
        }
        .card_ {
          font-size: 12px;
          color: #333;
          margin-top: 5px;
        }
      }
      .right_ {
        .money_ {
          font-size: 13px;
          color: #333;
          font-weight: 500;
        }
        .text_ {
          color: #333;
          font-size: 11px;
          margin-top: 3px;
        }
      }
    }
  }
  .score-detail{
    font-size: 12px;
    line-height: 18px;
    color: #333;
    font-family: PingFangSC-Regular;
    text-align: right;
    margin-top: 30px;
    .bank_item{
      align-items: flex-start;
      margin-top: 8px;
      height: auto;
      padding: 0;
      background-color: transparent;
    }
    .title {
      color: #999;
    }
  }
  .tips_ {
    margin-top: 27px;
    .title_ {
      font-size: 12px;
      color: #333;
      font-weight: 500;
      text-align: left;
    }
    .notes_ {
      margin-top: 27px;
      p {
        font-size: 12px;
        text-align: left;
        color: #666;
        line-height: 20px;
      }
    }
  }
  .bottom_ {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    position: fixed;
    height: 95px;
    left: 0;
    bottom: 34px;
    width: 100%;
    padding: 10px 22px 8px;
    background-color: #fff;
    img {
      width: 15px;
      height: 15px;
    }
    .read_ {
      color: #ccc;
      font-size: 13px;
      margin-left: 3px;
    }
    .withdraw_btn {
      width: 100%;
      color: #fff;
      font-size: 15px;
      text-align: center;
      height: 45px;
      line-height: 45px;
      background: linear-gradient(45deg, #ff7c6c 0%, #ffa297 100%);
      border-radius: 7px;
    }
  }
}
</style>
